import React from 'react';
export function HeroSection() {
  return <div className="bg-[#9B0137] py-16 px-4" data-id="element-1105">
      <div className="max-w-4xl mx-auto text-center" data-id="element-1106">
        <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm inline-block mb-6" data-id="element-1107">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Breton%20Machine%20Tools.png" alt="Breton Machine Tools Logo" className="block h-24 md:h-32 w-auto mx-auto" data-id="element-1108" />
        </div>
        <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight uppercase mb-2" data-id="element-1109">
          GENESI
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-white/90 uppercase tracking-wide" data-id="element-1110">
          Large Scale Thermoplastic Additive Manufacturing
        </h2>
      </div>
    </div>;
}